"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("./Button"));
var isiOS_1 = require("./utils/isiOS");
function AppButton(props) {
    var storeLink = props.storeLink, appLink = props.appLink, rest = __rest(props, ["storeLink", "appLink"]);
    var iOS = (0, isiOS_1.isiOS)();
    var delay = iOS ? 5000 : 500;
    var handleClick = function (e) {
        e.preventDefault();
        if (window) {
            if (!(0, isiOS_1.isMobile)() && storeLink) {
                window.location.href = storeLink;
                return;
            }
            // will console error and not redirect if app not installed
            if (appLink)
                window.location.href = appLink;
            var loadTimestamp_1 = Date.now();
            if (storeLink) {
                setTimeout(function () {
                    // go to app store if deep link fails
                    var timeoutTimestamp = Date.now();
                    if (!iOS || timeoutTimestamp - loadTimestamp_1 < 1000) {
                        window.location.href = storeLink;
                    }
                }, delay);
            }
        }
    };
    return (react_1.default.createElement(Button_1.default, __assign({}, rest, { onClick: handleClick })));
}
exports.default = AppButton;
